/** CSV export helpers (pure). */

/**
 * Escapes one cell. Cells that start with a formula trigger (= + - @ tab CR)
 * are prefixed with an apostrophe to prevent CSV/formula injection in Excel.
 */
export function csvCell(value) {
  let text = String(value ?? '');
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function winnersToCsv(winners) {
  const header = ['Tier', 'Prize', 'Display name', 'Username', 'Comment', 'Drawn at', 'Status', 'Eligible pool', 'Mode'];
  const rows = winners.map((w) => [
    w.tierName,
    w.prize,
    w.displayName,
    w.username,
    w.comment,
    w.drawnAt,
    w.voided ? 'Voided' : 'Winner',
    w.poolSize,
    w.mode,
  ]);
  // BOM so Excel opens UTF-8 (Burmese, emoji) correctly.
  return `﻿${[header, ...rows].map((row) => row.map(csvCell).join(',')).join('\r\n')}`;
}
